export const iconFontAwesomeHumanitarianToiletsPortable = (
	<i className="fa-solid fa-toilets-portable"></i>
);
